import { render } from "./Header.vue?vue&type=template&id=2beb70dc&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2beb70dc&scoped=true&lang=css"
import "./Header.vue?vue&type=style&index=1&id=2beb70dc&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beb70dc"]])

export default __exports__